export const EFECTIVO = 'EFE'
export const TARJETA = 'TAR'
export const BANCO = 'BAN'

export const __dictionary = {
  [EFECTIVO]: {
    id: EFECTIVO,
    nombre: 'EFECTIVO'
  },
  [TARJETA]: {
    id: TARJETA,
    nombre: 'TARJETA'
  },
  [BANCO]: {
    id: BANCO,
    nombre: 'BANCO'
  }
}

export const __array = [__dictionary[EFECTIVO], __dictionary[TARJETA], __dictionary[BANCO]]
